import React, { useState, useEffect, useRef } from 'react';
import { CheckCircle, Download, List, Printer, Save, Upload, ScrollText, Plus } from 'lucide-react';
import {
    CDropdown,
} from '@coreui/react';
import { motion } from 'framer-motion';

const ProviderPatientFloatingButtonTest = ({ toPDF,togglePoacFreetype, setTogglePoacFreetype,showAddPoac, targetRef,appointmentForthisPatientNotSeen=true, isProviderPage=false,saveTreatsShell,superBillForNote = null, noteStructureRef,showAddHistory=false,handleAddHistoryToggle, submitTreatsShell, setNoteView, handleToggleAddDiagnosis, isProviderNote = false }) => {

    console.log(showAddPoac,'showAddPoac')

    const [isShowing, setIsShowing] = useState(false);
    const dropdownRef = useRef(null);

    // Toggle the dropdown menu
    const toggleMenu = () => {
        setIsShowing(prev => !prev);
    };
    const handlePrint = () => {
        toggleMenu()
        targetRef.current.style.padding = '40px';
        toPDF()
        targetRef.current.style.padding = '0px';
    }

    const [isSavingNote, setIsSavingNote] = useState(false);

    // Handle outside click
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsShowing(false);
        }
    };

    // Add and remove event listeners
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Animation variants for the dropdown and children
    const dropdownVariants = {
        hidden: { height: 0 },
        visible: {
            height: "auto",
            transition: {
                duration: 0.3,
                ease: "easeInOut",
                when: "beforeChildren",
                staggerChildren: 0.3, // Stagger each child by 0.3 seconds
            }
        }
    };

    const itemVariants = {
        hidden: { visiblity: "hidden", opacity: 0, y: 10 },
        visible: { visiblity: "visible", opacity: 1, y: 0 },
        transition: { type: "spring", stiffness: 100 }
    };

    return (
        <div className='floating-patient-button'>
            <CDropdown ref={dropdownRef}>
                <div
                    onClick={toggleMenu}
                    size="sm"
                    style={{ background: "var(--ui-color-primary, #2b7cd3)" }}
                    className='d-flex align-items-center justify-content-center focus-transparent rounded-circle text-white shadow-ex outline-none floating-button-opt'>
                    <List />
                </div>
                <motion.div
                    className='dropdown-menu-boxs'
                    variants={dropdownVariants}
                    initial="hidden"
                    animate={isShowing ? "visible" : "hidden"}
                    style={{ overflow: "hidden" }}
                >

                    <motion.div variants={itemVariants} onClick={handleToggleAddDiagnosis} className='dropdown-items-custom' style={{ width: "100%" }}>
                        <span className='d-flex align-items-center gap-2 opt-icon'>
                            <p className='floating-button-label p-0 m-0'>Add Diagnosis</p>
                            <Plus className='rounded-circle' style={{ background: "var(--ui-color-primary, #2b7cd3)", padding: "8px", width: "40px" }} strokeWidth={1.1} size={40} />
                        </span>
                    </motion.div>
                    <motion.div onClick={() => { setNoteView(true); toggleMenu() }} variants={itemVariants} className='dropdown-items-custom' style={{ width: "100%" }}>
                        <span className='d-flex align-items-center gap-2 opt-icon'>
                            <p className='floating-button-label p-0 m-0'> Note Preview</p>
                            <ScrollText className='rounded-circle' style={{ background: "var(--ui-color-primary, #2b7cd3)", padding: "8px" }} strokeWidth={1.1} size={40} />
                        </span>
                    </motion.div>

                    {/* {showAddHistory && <motion.div onClick={()=>{
                        handleAddHistoryToggle()
                    }} variants={itemVariants} className='dropdown-items-custom' style={{ width: "100%" }}>
                        <span className='d-flex align-items-center gap-2 opt-icon'>
                            <p className='floating-button-label p-0 m-0'>Add History</p>
                            <Plus className='rounded-circle' style={{ background: "var(--ui-color-primary, #2b7cd3)", padding: "8px" }} strokeWidth={1.1} size={40} />
                        </span>
                    </motion.div>} */}
                    {!isProviderNote && 
                    <>
                    
                    <motion.div onClick={handlePrint} variants={itemVariants} className='dropdown-items-custom' style={{ width: "100%" }}>
                        <span className='d-flex align-items-center gap-2 opt-icon'>
                            <p className='floating-button-label p-0 m-0'>Print PDF</p>
                            <Printer className='rounded-circle' style={{ background: "var(--ui-color-primary, #2b7cd3)", padding: "8px" }} strokeWidth={1.1} size={40} />
                        </span>
                    </motion.div>
                    </>
                    }
                    {/* {isProviderPage && superBillForNote && appointmentForthisPatientNotSeen && <motion.div onClick={() => {
                        submitTreatsShell()
                        toggleMenu()
                    }} variants={itemVariants} className='dropdown-items-custom d-flex align-items-center gap-2 ' style={{ width: "100%" }}>
                        <span className='d-flex align-items-center gap-2 opt-icon'>
                            <p className='floating-button-label p-0 m-0'>{isProviderNote ? 'Sign' : 'Submit'} </p>
                            <Upload className='rounded-circle' style={{ background: "var(--ui-color-primary, #2b7cd3)", padding: "8px" }} strokeWidth={1.1} size={40} />
                        </span>
                    </motion.div>} */}
                    {!isProviderPage && 
                    <motion.div onClick={() => {
                        submitTreatsShell()
                        toggleMenu()
                    }} variants={itemVariants} className='dropdown-items-custom d-flex align-items-center gap-2 ' style={{ width: "100%" }}>
                        <span className='d-flex align-items-center gap-2 opt-icon'>
                            <p className='floating-button-label p-0 m-0'>{isProviderNote ? 'Sign' : 'Submit'} </p>
                            <Upload className='rounded-circle' style={{ background: "var(--ui-color-primary, #2b7cd3)", padding: "8px" }} strokeWidth={1.1} size={40} />
                        </span>
                    </motion.div>
                    }
                    {!isProviderPage && 
                    <motion.div onClick={() => {
                        saveTreatsShell()
                        toggleMenu()
                    }} variants={itemVariants} className='dropdown-items-custom d-flex align-items-center gap-2 ' style={{ width: "100%" }}>
                        <span className='d-flex align-items-center gap-2 opt-icon'>
                            <p className='floating-button-label p-0 m-0'>Save </p>
                            <Download className='rounded-circle' style={{ background: "var(--ui-color-primary, #2b7cd3)", padding: "8px", }} strokeWidth={1.1} size={40} />
                        </span>
                    </motion.div>
                    }
                    {
                        isProviderPage && showAddPoac &&
                        <motion.div onClick={() => {
                            setTogglePoacFreetype(true)
                        toggleMenu()
                    }} variants={itemVariants} className='dropdown-items-custom d-flex align-items-center gap-2 ' style={{ width: "100%" }}>
                        <span className='d-flex align-items-center gap-2 opt-icon'>
                            <p className='floating-button-label p-0 m-0'>Add POAC </p>
                            <Plus className='rounded-circle' style={{ background: "var(--ui-color-primary, #2b7cd3)", padding: "8px", }} strokeWidth={1.1} size={40} />
                        </span>
                    </motion.div>
                    }
                    {/* {isProviderPage && <motion.div onClick={async() => {
                        setIsSavingNote(true);
                        await saveTreatsShell()
                        setIsSavingNote(false);
                        toggleMenu()
                    }} variants={itemVariants} className='dropdown-items-custom d-flex align-items-center gap-2 ' style={{ width: "100%" }}>
                        <span className='d-flex align-items-center gap-2 opt-icon'>
                            <p className='floating-button-label p-0 m-0'>{isSavingNote ? 'Saving...' : 'Save Note'} </p>
                            <Download className='rounded-circle' style={{ background: "var(--ui-color-primary, #2b7cd3)", padding: "8px", }} strokeWidth={1.1} size={40} />
                        </span>
                    </motion.div>} */}
                </motion.div>
            </CDropdown>
        </div>
    );
};

export default ProviderPatientFloatingButtonTest;
